import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const upload = async (data: any) => {
  const type = "order";

  return httpRequest.upload(`/mdi/media/file/${type}/upload`, data);
};
